export default __webpack_public_path__ + "images/38d893ef965998e090532d390eef1a93.svg";